import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const WhiteDwarf = ({ position, scale = 1 }) => {
    return (
        <group position={position} scale={scale * 0.4}> {/* Very small */}
            {/* 1. Dense Core */}
            <mesh>
                <sphereGeometry args={[0.5, 32, 32]} />
                <meshStandardMaterial 
                    color="#ffffff"
                    emissive="#ffffff"
                    emissiveIntensity={25}
                    roughness={0.1}
                />
                <pointLight distance={8} intensity={6} color="white" />
            </mesh>

            {/* 2. Planetary Nebula (Expelled gas ring) */}
            <mesh rotation={[Math.PI / 3, 0, 0]}>
                <torusGeometry args={[1.5, 0.1, 16, 64]} />
                <meshBasicMaterial color="#00ffcc" transparent opacity={0.3} blending={THREE.AdditiveBlending} />
            </mesh>
            <mesh rotation={[-Math.PI / 4, 0, 0]}>
                <torusGeometry args={[1.2, 0.05, 16, 64]} />
                <meshBasicMaterial color="#ff00cc" transparent opacity={0.2} blending={THREE.AdditiveBlending} />
            </mesh>
        </group>
    );
};

export default WhiteDwarf;